module.exports = __webpack_public_path__ + "static/img/Rtaf_radio_1.34ff130.png";